import React, { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  balanceHistoryTransaction,
  rewardLeaderboardTransaction,
  updateCoinBalance,
  walletBalanceList,
} from "store/actions";
import Table from "components/Table";
import Columns from "./Columns";
import FormikForm from "components/shared/FormikForm";
import WalletBalancePop from "components/Modals/WalletBalancePop";
import Validation from "./Validation";
import BalanceTransactionModal from "components/Modals/BalanceTransactionHistoryDetailPopup/BalanceTransactionDetailPopup";

const InputFieldsForSearch = [
  {
    name: "search",
    type: "text",
    label: "",
    placeholder: "Search...",
  },
  {
    name: "transactionType",
    label: "",
    type: "select",
    placeholder: "Select Transaction Type",
    options: [
      { value: "Credit", label: "Credit" },
      { value: "Debit", label: "Debit" },
    ],
  },
  {
    name: "type",
    label: "",
    type: "select",
    placeholder: "Select Type",
    options: [
      { value: "Admin Reward", label: "Admin Reward" },
      { value: "Admin Adjustment", label: "Admin Adjustment" },
      { value: "Claim Reward", label: "Claim Reward" },
      { value: "Game Reward", label: "Game Reward" },
      { value: "Leaderboard Reward", label: "Leaderboard Reward" },
      { value: "Welcome Reward", label: "Welcome Reward" },
    ],
  },
];

const initialValuesForFilter = {
  search: "",
  transactionType: "",
  type: "",
};

const List = ({ userDetails }) => {
  const dispatch = useDispatch();
  const [balanceTrxn, setBalanceTrxn] = useState(false);
  const [balanceTrxnData, setBalanceTrxnData] = useState(false);
  const [id, setId] = useState(null);

  const { balanceHistoryData, loading, totalBalanceHistoryData } = useSelector(
    ({ Users }) => Users,
  );

  const [columns, setcolumns] = useState(Columns({ dataField: "", text: "" }));
  const [filter, setFilter] = useState({
    page: 1,
    limit: 10,
    order: -1,
    orderBy: "date_created_utc",
    search: "",
    userId: "",
    transactionType: "",
    type: "",
  });


  useEffect(() => {
    if (!userDetails?._id) return;

    setFilter((prev) => ({
      ...prev,
      userId: userDetails._id,
    }));
  }, [userDetails]);

  useEffect(() => {
    if (!filter.userId) return;
    dispatch(balanceHistoryTransaction({ data: filter }));
    setcolumns(Columns({ handleEditHandler }));
  }, [filter]);

  const handleFilterForm = (info) => {
    setFilter((prev) => ({
      ...prev,
      search: info.search,
      transactionType: info.transactionType,
      type: info.type,
      page: 1,
    }));
  };

  const handleEditHandler = (info) => {
    setBalanceTrxn(true);
    setId(info?._id);
    setBalanceTrxnData(info);
  };

  return (
    <>
      <BalanceTransactionModal
        data={balanceTrxnData}
        show={balanceTrxn}
        handleClose={() => {
          setBalanceTrxn(false);
        }}
        title={"Balance Transaction History Details"}
        id={id}
      />

      <div className="section-body">
        <div className="card">
          <div className="row justify-content-between">
            <div className="col-12">
              <div className="card-header">
                <FormikForm
                  initialValues={initialValuesForFilter}
                  onSubmit={handleFilterForm}
                  loading={loading}
                  inputFields={InputFieldsForSearch}
                  buttonText={"Search"}
                />
              </div>
            </div>
          </div>
        </div>

        {balanceHistoryData?.length > 0 && (
          <Table
            data={balanceHistoryData}
            columns={columns}
            setFilter={setFilter}
            total={totalBalanceHistoryData}
            filter={filter}
          />
        )}

        {!loading && balanceHistoryData?.length === 0 && (
          <p style={{ textAlign: "center" }}>No Data Found</p>
        )}
      </div>
    </>
  );
};

export default List;
